export const DEFAULT_HEADERS = {
    'Content-Type': 'application/json',
};
//# sourceMappingURL=default-headers.js.map